import React from "react";
import { ProtectedRoute } from "./components/protectedRoute";

import { Router, Route, Switch } from "react-router-dom";
 
import Login from "./components/Login";
import Grid from "@material-ui/core/Grid";
import Header from "./components/Header";
import Footer from "./components/Footer";
import LeftSideBar from "./components/LeftSideBar";
import ServerDataTable from "./components/ServerDataTable";
import ServiceDataTable from "./components/ServiceDataTable";
import showProfile from  "./components/ProfilePage";

import { makeStyles } from "@material-ui/core/styles";
import { grey, red, green } from "@material-ui/core/colors";
import history from './components/history';
const useStyles = makeStyles((theme) => ({
  root:{
    //flexGrow:1
  },
  rootGrid: {
    //marginTop: theme.spacing(8),
    //display: "flex",
    flexDirection: "column",
    // alignItems: "center",
    flex:1
  },
  contentGrid: {
    marginTop: "10vh",
    alignItems: "stretch",
    minHeight: "70vh",
    flexDirection: "row",
  },
  contentGridCenterItem: {
    //flexGrow: 1,
   // backgroundColor:red[100],
   // overflow: "hidden"
  // backgroundColor: red[100],

  // alignSelf:"baseline"
  },
  gutter:{
  //  background:green[200],    
  },
 
}));

function App(props) {
  const classes = useStyles();
 
  return (
    <div className="App">
       <Grid container className={classes.rootGrid}>
        <Grid item className={classes.header}>
          <Header />
        </Grid> 
         <Grid container item xs={12} className={classes.contentGrid}> 
         <Grid item  lg={3} className={classes.gutter}>
           <LeftSideBar/>
          </Grid>
          
          <Grid item sm={12} lg={9} className={classes.contentGridCenterItem}>
            <Router history={history}> 
              <Switch>
                <Route exact path="/" component={Login}  />
                <ProtectedRoute
                  exact
                  path="/servers"
                  component={ServerDataTable}
                />
                 <ProtectedRoute
                  exact
                  path="/services"
                  component={ServiceDataTable}
                />
                <ProtectedRoute
                  exact
                  path="/profile"
                  component={showProfile}
                />
                <Route path="*" component={() => "404 NOT FOUND"} />
              </Switch>
            </Router>
           </Grid>
         {/* <Grid item lg={2} className={classes.gutter}>           
          </Grid> */}
        </Grid>
        <Grid item className={classes.footer}>
          <Footer />
        </Grid>
      </Grid> 
    </div>
  );
}

export default App;
